// [ai] /journal: the entries by month (newest first), the streak, today's date; empty → the way to the first page.
import { Link } from "react-router";
import { useAtlasQuery } from "../api/query";
import { Loading, n, PageError } from "./common";
export type JournalData = { entries: { href: string; date: string; instrument: string; emoji: string; title: string; updated: string | null }[]; streak: number; today: { name: string; title: string; emoji: string; done: boolean; href: string }[] };
const MONTH = new Intl.DateTimeFormat("en", { month: "long", year: "numeric" });
export function JournalPage() {
  const q = useAtlasQuery<JournalData>("journal", { n: 1000 });
  if (q.isError) return <PageError error={q.error} title="Journal" />;
  const d = q.data; const months = new Map<string, JournalData["entries"]>();
  for (const e of d?.entries ?? []) { const k = MONTH.format(new Date(e.date + "T12:00:00")); if (!months.has(k)) months.set(k, []); months.get(k)!.push(e); }
  const today = new Date(); const iso = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  return (
    <section className="at-page at-journal"><p className="at-eyebrow">Today</p><h1>Journal</h1>
      {!d ? <Loading /> : !d.entries.length ? <p>No entries yet — <Link to="/do/morning">write this morning's page</Link>.</p> : <>
        <p className="at-streak">{n(d.entries.length, "entry").replace("entrys", "entries")} · streak {n(d.streak, "day")} · {iso}</p>
        {[...months].map(([m, rows]) => <section key={m}><h2>{m}</h2><ol className="at-recent">{rows.map(e => <li key={e.href}><Link to={e.href}>{e.emoji} {e.title}</Link></li>)}</ol></section>)}
      </>}
    </section>
  );
}
